import React from "react";
import { Room } from "livekit-client";
import CustomChat from "./CustomChat";

interface StudioChatSidebarProps {
    room: Room | null;
}

const StudioChatSidebar: React.FC<StudioChatSidebarProps> = ({ room }) => {
    return <CustomChat room={room} />;
};

export default StudioChatSidebar;
